"use strict";const e=["button","[focusable]","[href]","input","label","select","textarea","[tabindex]"],o=':not([tabindex="-1"])';export const userFocusableSelector=e.join(`${o}, `)+o,focusableSelector=e.join(", ");
//# sourceMappingURL=focusable-selectors.js.map
